export class ConsultaDetalhada {
    ids: number[] = [];
    montadora: string;
    modelo: string;
    motor: string;
    injecao: string;
    transmissao: string;
    anoInicial: string;
    complemento: string;
}
